<template>
    <rkm-area
        v-if="data.form"
        title="Protocolo"
        type="fieldset"
    >

        <Form
            :data="data"
            :is-atendimento-medico="isAtendimentoMedico"
            :readonly="readonly"
        />


    </rkm-area>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    props: {
        data: { type: Object, required: true },
        isAtendimentoMedico: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
    },
}
</script>